import React from 'react';
import PropTypes from 'prop-types';
import Label from '../../components/foundations/Label';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import css from './FormSection.css';

const FormSection = ({ titleKey, descriptionKey, iconName, children }) => (
    <div className={css.section}>
        <div className={css.header}>
            <div className={css.titleRow}>
                <div className={css.iconWrapper}>
                    {iconName && <Icon name={iconName} size={IconSizes.SMALL} interactive={false} />}
                </div>
                <Label text={titleKey} type="h2" className={css.title} />
            </div>
            {descriptionKey && <Label text={descriptionKey} type="p" />}
        </div>
        {children}
    </div>
);

FormSection.propTypes = {
    titleKey: PropTypes.string.isRequired,
    descriptionKey: PropTypes.string,
    iconName: PropTypes.string,
    children: PropTypes.node,
};

export default FormSection;
